import React from 'react';

type BadgeVariant = 'active' | 'pending' | 'inactive' | 'danger' | 'info' | 'warning';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantMap: Record<BadgeVariant, string> = {
  active: 'status-active',
  pending: 'status-pending',
  inactive: 'status-inactive',
  danger: 'status-danger',
  info: 'status-info',
  warning: 'bg-amber-50 text-amber-700 border border-amber-200',
};

export default function Badge({ variant, children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-600 ${variantMap[variant]} ${className}`}
    >
      {children}
    </span>
  );
}